module.exports = __webpack_public_path__ + "static/media/gabi_avatar.6f1ccb61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gabi_avatar.jpg
// module id = 1002
// module chunks = 4